import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

// iOS vh height helper
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

// MENU CODE
jQuery(document).ready(function ($) {
  // VARIABLES
  const nav_btn = document.getElementById('menu_open');
  const fs_nav_btn = document.getElementById('menu_close');
  let master = gsap.timeline({ paused: true, reversed: true });
  const nav_links = document.getElementsByTagName('a');

  // EVENT LISTENERS
  nav_btn.addEventListener('click', activateMenu);
  fs_nav_btn.addEventListener('click', deactivateMenu);

  // FUNCTIONS
  function activateMenu() {
    master.reversed() ? master.play() : master.reverse();

    document.body.style.position = 'fixed';
    document.body.style.top = `${window.scrollY}px`;
    document.body.style.width = '100%';
  }

  function deactivateMenu() {
    master.reversed() ? master.play() : master.reverse();
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }

  function headerAnim() {
    const header = gsap.timeline();

    header.to('.header', {
      duration: 0.3,
      ease: 'power2.inOut',
      display: 'none',
      opacity: 0,
      y: -100
    });
    header.to(
      '.header__logo',
      {
        duration: 0.3,
        ease: 'power2.inOut',
        display: 'none',
        opacity: 0
      },
      '<'
    );
    header.to(
      '.header__open',
      { duration: 0.3, ease: 'power2.inOut', display: 'none', opacity: 0 },
      '<'
    );

    return header;
  }

  function fullscreenMenuAnim() {
    const fullscreen = gsap.timeline();

    fullscreen.to('#fullscreen_menu', {
      duration: 0.6,
      ease: 'power2.inOut',
      x: 0,
      opacity: 1
    });
    fullscreen.to(
      '.fs-menu__inner',
      { duration: 0.6, ease: 'power2.inOut', x: 0, opacity: 1 },
      '<0.2'
    );
    fullscreen.addLabel('open', '>');
    fullscreen.from(
      '.fs-menu__banner',
      { duration: 0.3, ease: 'power2.inOut', y: -100, opacity: 0 },
      'open'
    );
    fullscreen.from(
      '.fs-menu__main',
      {
        duration: 0.3,
        ease: 'power2.inOut',
        y: 100,
        opacity: 0
      },
      'open'
    );
    return fullscreen;
  }

  function navLinksAnim() {
    const navLinks = gsap.timeline();

    navLinks.to(['.fs-menu__nav', '.fs-menu__primary', '.fs-menu__item'], {
      duration: 0.8,
      opacity: 1,
      stagger: 0.2
    });

    return navLinks;
  }

  // HIDE HEADER
  master.add(headerAnim());
  master.add(fullscreenMenuAnim());
  master.add(navLinksAnim());
});

// WORK SROLL GALLERY
jQuery(document).ready(function ($) {
  // gsap.registerPlugin(ScrollTrigger);
  const images = gsap.utils.toArray('img');
  // const loader = document.querySelector('.loader--text');

  // const updateProgress = (instance) =>
  //   (loader.textContent = `${Math.round((instance.progressedCount * 100) / images.length)}%`);

  const scrollGallery = () => {
    document.body.style.overflow = 'auto';
    document.scrollingElement.scrollTo(0, 0);
    // gsap.to(document.querySelector('.loader'), { autoAlpha: 0 });

    gsap.utils.toArray('.play-intro-selector').forEach((section, index) => {
      const w = section.querySelector('.gallery__wrapper');
      const [x, xEnd] =
        index % 2
          ? [w.scrollWidth * -1, 0]
          : ['100%', (w.scrollWidth * 1.5 - section.offsetWidth) * -1];
      gsap.fromTo(
        w,
        { x },
        {
          x: xEnd,
          scrollTrigger: {
            trigger: section,
            scrub: 1
          }
        }
      );
    });
  };

  scrollGallery();
  // imagesLoaded(images).on('progress', updateProgress).on('always', scrollGallery);
});

// SWIPER
jQuery(document).ready(function ($) {
  if ($('.wrapper__about').length > 0) {
    let swiper = new Swiper('.swiper-team', {
      slidesPerView: 'auto',
      spaceBetween: 30,
      freeMode: true,
      loop: true
      // mousewheel: true
    });
  }
});

// MENU IMAGES

// const mediaQuery = window.matchMedia('(min-width: 992px)');

// function handleTabletChange(e) {
//   if (e.matches) {
//     jQuery(document).ready(function ($) {
//       let currentMenuItem = $('current-menu-item');
//       let menuItem = $('.menu-item');
//       let groupOne = $('#menu_bank_1');
//       let groupTwo = $('#menu_bank_2');
//       let groupThree = $('#menu_bank_3');
//       let groupFour = $('#menu_bank_4');

//       $(menuItem).mouseenter(function () {
//         if (this.classList.contains('menu-item-11')) {
//           $('.fs-menu__image-grid').hide();
//           groupOne.show();
//         }
//         if (this.classList.contains('menu-item-26')) {
//           $('.fs-menu__image-grid').hide();
//           groupTwo.show();
//         }
//         if (this.classList.contains('menu-item-25')) {
//           $('.fs-menu__image-grid').hide();
//           groupThree.show();
//         }
//         if (this.classList.contains('menu-item-24')) {
//           $('.fs-menu__image-grid').hide();
//           groupFour.show();
//         }
//       });
//     });
//   }
// }

// mediaQuery.addListener(handleTabletChange);
// handleTabletChange(mediaQuery);

// ARROW ANIMATIONS
// gsap.fromTo(
//   '#arrow-down-int',
//   { drawSVG: '0% 0%' },
//   { drawSVG: '0% 100%', delay: 0.5, duration: 1 }
// );

// ///////////////////////////////////////////////////////////////////////
// AJAX
// ///////////////////////////////////////////////////////////////////////
jQuery(document).ready(function ($) {});
